import { render, staticRenderFns } from "./programme_sub_detail.vue?vue&type=template&id=7c190d2a&"
import script from "./programme_sub_detail.vue?vue&type=script&lang=js&"
export * from "./programme_sub_detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports